import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';


const Footer = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle newsletter subscription logic here
  };


  return (
    <footer className="footer">
      <div className="cta-section-footer">
        <div className="cta-container-footer">
          <div className="cta-left">
            <h2>Let's Get Started →</h2>
          </div>
          <div className="cta-right">
            <form onSubmit={handleSubmit} className="newsletter-form">
              <input 
                type="email" 
                placeholder="Email" 
                className="email-input-footer" 
                required 
              />
              <button type="submit" className="submit-button-footer">
                Submit <span className="arrow">→</span>
              </button>
            </form>
            <p className="cta-text-footer">
            Ready to amplify your rewards?</p>
            <p className="cta-text-footer">
              Drop your email and we will be in touch soon</p>
          </div>
        </div>
      </div>

{/* start editing from here */}
<div className="footer-content">
        <div className="footer-container">
          <div className="footer-logo">
            <img src="/images/logo.svg" alt="Peak Mobile Logo" />
          </div>

          <div className="footer-links-container">
            <div className="footer-column">
              <h3>Quick Links</h3>
              <ul className="footer-links">
                <li><a href="/">Home</a></li>
                <li>
                <Link to="/about">About Us</Link>

                </li>
                <li><a href="/">Products</a></li>
                <li><a href="https://mypeakgames.com/home"
                target="_blank"
                rel="noopener noreferrer">My Peak Games</a></li>
                <li>
                <Link to="/careers">Careers</Link>

                </li>
                <li><Link to="/developers">Developers</Link></li>
                <li><Link to="/blog">Blog</Link></li>

              </ul>
            </div>

            <div className="footer-column">
              <h3>Products & Services</h3>
              <ul className="footer-links">
                <li> 
                <Link to="/airtime-rewards">Airtime Rewards</Link>
                </li>
                <li><Link to="/bulk-sms">Bulk SMS</Link></li>
                <li><Link to="/bulk-whatsapp">Whatsapp</Link></li>
                <li><Link to="/bulk-data">Mobile Data Rewards</Link></li>
                
                <li><a href="/">Sponsored Data</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h3>Get In Touch</h3>
              <ul className="footer-contact">
                <li>
                  <img src="/images/icons/location.svg" alt="Location" className="contact-icon" />
                  3rd Floor, The promenade, Westlands Nairobi
                </li>
                <li>
                  <img src="/images/icons/phone-call.svg" alt="Phone" className="contact-icon" />
                  <a href="tel:+254759422480">0759422480</a>
                </li>
                <li>
                  <img src="/images/icons/mail.svg" alt="Email" className="contact-icon" />
                  <a href="mailto:chat@peakmobile.co.ke">chat@peakmobile.co.ke</a>
                </li>
              </ul>

              <h4>Follow Us On</h4>
              <div className="social-icons">
                {/* <a href="https://twitter.com/peakmobile" target="_blank" rel="noopener noreferrer">
                  <img src="/images/icons/twitter.svg" alt="Twitter" />
                </a>
                <a href="https://facebook.com/peakmobile" target="_blank" rel="noopener noreferrer">
                  <img src="/images/icons/faceb.svg" alt="Facebook" />
                </a> */}
                <a href="https://linkedin.com/company/peak-mobile" target="_blank" rel="noopener noreferrer">
                  <img src="/images/icons/linkedin.svg" alt="LinkedIn" />
                </a>
                <a href="https://www.instagram.com/peakmobile_ke/" target="_blank" rel="noopener noreferrer">
                  <img src="/images/insta.svg" alt="Instagram" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-container">
          <p className="copyright">Copyright © 2025 peakmobile.co.ke</p>
          <div className="legal-links">
            {/* <a href="/terms">Terms & Conditions</a> */}
            <a href="/privacy">Privacy Policy</a>
            <a href="/sustainability">Sustainability and Carbon Neutrality Policy</a>

            
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
